// ⚠️ Archivo generado automáticamente — no editar manualmente
import ImageTest from "../../assets/img/welcome-screen/f&f1.png";
import qr_camera from "../../assets/img/admin/qr-camera.png";
import background from "../../assets/img/main-screen/background.jpg";
import modal_image from "../../assets/img/reel-section/confirmation/modal-image.png";
import confirmation_qr from "../../assets/img/reel-section/confirmation-qr.png";
import sobre from "../../assets/img/reel-section/content-fifth-section/sobre.png";
import tap from "../../assets/img/reel-section/content-fifth-section/tap.png";
import dress from "../../assets/img/reel-section/content-fourth-section/dress.png";
import dresscode_photo from "../../assets/img/reel-section/content-fourth-section/dresscode-photo.png";
import suit from "../../assets/img/reel-section/content-fourth-section/suit.png";
import bouquet from "../../assets/img/reel-section/content-second-section/bouquet.png";
import card_background from "../../assets/img/reel-section/content-second-section/card-background.png";
import church from "../../assets/img/reel-section/content-second-section/church.png";
import church_2 from "../../assets/img/reel-section/content-third-section/church.png";
import church2 from "../../assets/img/reel-section/content-third-section/church2.png";
import couple2 from "../../assets/img/reel-section/content-third-section/couple2.png";
import glasses from "../../assets/img/reel-section/content-third-section/glasses.png";
import golden_badge_f_f from "../../assets/img/reel-section/content-third-section/golden-badge-f&f.png";
import invite_white_background from "../../assets/img/reel-section/content-third-section/invite-white-background.png";
import just_married from "../../assets/img/reel-section/content-third-section/just-married.png";
import white_flowers2 from "../../assets/img/reel-section/content-third-section/white-flowers2.png";
import dress_2 from "../../assets/img/reel-section/dress.png";
import first_reel from "../../assets/img/reel-section/first_reel.png";
import first_reel2 from "../../assets/img/reel-section/first_reel2.png";
import first_reel_background from "../../assets/img/reel-section/first_reel_background.jpg";
import img_1 from "../../assets/img/reel-section/gallery-section/gallery-photos/1.png";
import img_10 from "../../assets/img/reel-section/gallery-section/gallery-photos/10.png";
import img_2 from "../../assets/img/reel-section/gallery-section/gallery-photos/2.png";
import img_3 from "../../assets/img/reel-section/gallery-section/gallery-photos/3.png";
import img_4 from "../../assets/img/reel-section/gallery-section/gallery-photos/4.png";
import img_5 from "../../assets/img/reel-section/gallery-section/gallery-photos/5.png";
import img_6 from "../../assets/img/reel-section/gallery-section/gallery-photos/6.png";
import img_7 from "../../assets/img/reel-section/gallery-section/gallery-photos/7.png";
import img_8 from "../../assets/img/reel-section/gallery-section/gallery-photos/8.png";
import img_9 from "../../assets/img/reel-section/gallery-section/gallery-photos/9.png";
import new_section from "../../assets/img/reel-section/new-section.png";
import second_reel_background from "../../assets/img/reel-section/second_reel_background.png";
import main_image from "../../assets/img/reel-section/sixth-section/main-image.png";
import second_image from "../../assets/img/reel-section/sixth-section/second-image.png";
import white_background from "../../assets/img/reel-section/white-background.png";
import toast_succes from "../../assets/img/toast-succes.png";
import background_2 from "../../assets/img/welcome-screen/background.jpg";

export const allPreloadImages = [
  ImageTest,
  qr_camera,
  background,
  modal_image,
  confirmation_qr,
  sobre,
  tap,
  dress,
  dresscode_photo,
  suit,
  bouquet,
  card_background,
  church,
  church_2,
  church2,
  couple2,
  glasses,
  golden_badge_f_f,
  invite_white_background,
  just_married,
  white_flowers2,
  dress_2,
  first_reel,
  first_reel2,
  first_reel_background,
  img_1,
  img_10,
  img_2,
  img_3,
  img_4,
  img_5,
  img_6,
  img_7,
  img_8,
  img_9,
  new_section,
  second_reel_background,
  main_image,
  second_image,
  white_background,
  toast_succes,
  background_2,
];
